import {
  useModalOldContext,
  WSButton,
  WSButtons,
  WSModalOld,
  WSText
} from "@wingspanhq/fe-component-library";
import { Deduction } from "@wingspanhq/wingspan-api-sdk";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import React from "react";
import { useHistory } from "react-router-dom";
import { ErrorAlert } from "@components/ErrorAlert";
import { queriesDeductions } from "@query";
import { goBackOrToParent } from "../../../../utils/goToParentRoute";

type Props = {
  deduction: Deduction;
};

export const DELETE_DEDUCTION_MODAL = "DELETE_DEDUCTION_MODAL";

export const Inner: React.FC<Props> = ({ deduction }) => {
  const { closeModal } = useModalOldContext();
  const history = useHistory();
  const onClose = () => goBackOrToParent(history);

  const [deleteDeduction, deleteDeductionMeta] =
    queriesDeductions.deleteDeduction.useMutation({
      onSuccess: () => {
        closeModal(DELETE_DEDUCTION_MODAL);
        onClose();
      }
    });

  const deductedAmount = (deduction.application ?? [])
    .map(a => a.amountDeducted ?? 0)
    .reduce((a, b) => a + b, 0);

  const remainingAmount = deductedAmount
    ? (deduction.amount ?? 0) - deductedAmount
    : 0;

  return (
    <>
      {remainingAmount && deduction.currency ? (
        <WSText mt="XL">
          {/* v3 types `Deduction.currency` as a bare string (unlike
              `PayableRow.currency`, which is the `Currency` enum), so it is
              narrowed once here at the formatting boundary. */}
          {formatMoney(deductedAmount, deduction.currency as Currency)} has
          already been deducted from previous invoices. Only the remaining
          balance will be cancelled.
        </WSText>
      ) : null}

      <ErrorAlert
        mt="XL"
        error={deleteDeductionMeta.error}
        context="Deduction"
      />

      <WSButtons mt="3XL">
        <WSButton.Tertiary onClick={() => closeModal(DELETE_DEDUCTION_MODAL)}>
          Go Back
        </WSButton.Tertiary>
        <WSButton
          destructive
          loading={deleteDeductionMeta.isLoading}
          onClick={() =>
            deleteDeduction({ deductionId: deduction.id as string })
          }
        >
          Delete
        </WSButton>
      </WSButtons>
    </>
  );
};

export const DeleteDeduction: React.FC = () => {
  return (
    <WSModalOld
      name={DELETE_DEDUCTION_MODAL}
      size="XS"
      title="Are you sure you want to delete this deduction?"
    >
      {({ deduction }) => <Inner deduction={deduction} />}
    </WSModalOld>
  );
};
